import loadScript from './load_script'

export const init = () => {
  return loadScript('https://www.google-analytics.com/analytics.js')
}
